// extracted by mini-css-extract-plugin
export default {"accordion":"EarMoldSection_accordion__dyraP","toggleGroup":"EarMoldSection_toggleGroup__CL9hx"};